import { InjectionToken } from '@angular/core';

/** Presente apenas no Bardo. A Central de Ajuda só faz sentido nesse app. */
export const FEATURE_S_HEADER_HELP = new InjectionToken<boolean>(
  'FEATURE_S_HEADER_HELP'
);
